import ReactMarkdown from "react-markdown";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";

const mdPlugins = {
  remarkPlugins: [remarkMath],
  rehypePlugins: [rehypeKatex],
};

interface MarkdownInlineProps {
  children: string;
  className?: string;
}

export function normalizeMarkdownMath(content: string): string {
  const source = content
    .replace(/\r\n/g, "\n")
    .replace(/\\\[([\s\S]*?)\\\]/g, (_match, expression: string) => {
      const trimmed = expression.trim();
      return trimmed ? `\n\n$$\n${trimmed}\n$$\n\n` : "";
    })
    .replace(/\\\(([\s\S]*?)\\\)/g, (_match, expression: string) => {
      const trimmed = expression.trim();
      return trimmed ? `$${trimmed}$` : "";
    })
    .split("\n")
    .map((line) => {
      const withoutCodeIndent = line.replace(/^\s{4,}/, "");
      return withoutCodeIndent.replace(/^\*\s+/, "- ");
    })
    .join("\n");
  let normalized = "";
  let cursor = 0;

  while (cursor < source.length) {
    const open = source.indexOf("$$", cursor);
    if (open === -1) {
      normalized += source.slice(cursor);
      break;
    }

    const close = source.indexOf("$$", open + 2);
    if (close === -1) {
      normalized += source.slice(cursor);
      break;
    }

    normalized += source.slice(cursor, open);
    const expression = source.slice(open + 2, close).trim();
    if (expression) {
      normalized += `\n\n$$\n${expression}\n$$\n\n`;
    }
    cursor = close + 2;
  }

  return normalized.replace(/\n{3,}/g, "\n\n").trim();
}

export function MarkdownInline({ children, className }: MarkdownInlineProps) {
  const content =
    typeof children === "string" ? normalizeMarkdownMath(children) : "";
  if (!content.trim()) return null;
  return (
    <div className={className ?? "gac-md-inline"}>
      <ReactMarkdown {...mdPlugins}>{content}</ReactMarkdown>
    </div>
  );
}
